define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/ViewRef",
	"csi/heading/Aggregate",
	"csi/heading/String",
	"Specification"
], function(declare, lang, ViewRef, Aggregate, StringRen, Specification) {

	return declare(StringRen, {
		/**
		 * @override
		 * Use the default controller if there's no placements at the site level, as if the pure string
		 */
		_getRenderActionForHeading(ctx, h) {
			const sizeChartAdmin = ctx.cache.getNode(Specification.URL_ADMIN);

			if (sizeChartAdmin?.Placements.length) {
				return lang.mixin(new Aggregate(), {
					classController: "Specification.ItemPlacementController",
					m_viewRef: lang.mixin(new ViewRef(), {
						m_url: Specification.URL_ADMIN,
						m_id: "Placement"
					})
				});
			}

			return this.inherited(arguments);
		}
	});
});